<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5">
        <q-tree
          ref="dept-multi"
          :nodes="deptTree"
          node-key="deptCd"
          label-key="deptName"
          default-expand-all
        />
      </div>
    </div>
  </div>
</template>

<script>
import arrayToTree from 'array-to-tree';
import selectConfig from '@/js/selectConfig';
export default {
  name: 'dept-manage',
  data() {
    return {
      deptTree: [],
      listUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // api scope
      this.listUrl = selectConfig.mdm.dept.list.url + '/test';
      // list scope
      this.getList();
    },
    getDeptList() {
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.deptTree = this.convertTree(_result.data);
      },);
    },
    convertTree(_treeBases) {
      if (!_treeBases || _treeBases.length <= 0) return null;
      var tree = arrayToTree(_treeBases, {
        parentProperty: 'upDeptCd',
        customID: 'deptCd',
      });
      return tree;
    },
  }
};
</script>
